// TODO(RBAC, parent #641 #647): admin only
import { useCallback } from 'react'

import { create } from '@bufbuild/protobuf'
import { createClient } from '@connectrpc/connect'
import { useTransport } from '@connectrpc/connect-query'
import {
  GetWorkflowTemplateDeletabilityRequestSchema,
  WorkflowTemplateService,
} from '@ebalance/proto/bffuser/v1/workflow_template_service_pb'

import {
  type DeleteEntry,
  parseDeleteEntry,
} from '~/pages/AdminWorkflowTemplates/models/deleteEntry'

/**
 * 一覧の「削除」を押した時点で、 その雛形を消せるかを backend に問う (AC-WFT-061)。
 * 押した時点の値が要るので cache を使わず毎回呼ぶ。 確認に失敗した時はエラーを出さず
 * モーダルを開く側に倒す (モーダルの「削除」で backend がもう一度確かめる)。
 */
export function useWorkflowTemplateDeleteEntry(): {
  checkDeleteEntry: (templateId: string) => Promise<DeleteEntry>
} {
  const transport = useTransport()
  const checkDeleteEntry = useCallback(
    async (templateId: string): Promise<DeleteEntry> => {
      try {
        const response = await createClient(
          WorkflowTemplateService,
          transport,
        ).getWorkflowTemplateDeletability(
          create(GetWorkflowTemplateDeletabilityRequestSchema, {
            id: templateId,
          }),
        )
        return parseDeleteEntry(response)
      } catch {
        return { kind: 'confirm' }
      }
    },
    [transport],
  )
  return { checkDeleteEntry }
}
